import React from "react";
import { Alert, Box, Paper, Stack, Typography, CheckIcon, CheckCircleIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const AlertIcons = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Icons
        </Typography>

        <Typography variant="body1">
          The icon prop allows you to add an icon to the beginning of the alert
          component. This will override the default icon for the specified
          severity.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              '            <Stack sx={{ width: "100%" }} spacing={2}>\n' +
              '              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">\n' +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              "              <Alert\n" +
              "                iconMapping={{\n" +
              '                  success: <CheckCircleOutlineIcon fontSize="inherit" />,\n' +
              "                }}\n" +
              "              >\n" +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert icon={false} severity="success">\n' +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              "            </Stack>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                This is a success alert — check it out!
              </Alert>
              <Alert
                iconMapping={{
                  success: <CheckCircleIcon fontSize="inherit" />,
                }}
              >
                This is a success alert — check it out!
              </Alert>
              <Alert icon={false} severity="success">
                This is a success alert — check it out!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AlertIcons;
